export default __webpack_public_path__ + "static/media/chat-icon.36f9a0b3.svg";